import { Navigate } from 'react-router-dom';
import { LoadingState } from '@tutor/ui';
import { useAuthStore } from '../stores/auth.store';
import { LandingPage } from './public/LandingPage';

/**
 * The site root.
 *
 * A signed-in user goes straight to their dashboard; everyone else gets the public
 * landing page. Waiting for `restore()` to finish first avoids the flash of marketing
 * content that a returning user would otherwise see on every reload.
 */
export function RootRedirect() {
  const status = useAuthStore((state) => state.status);
  const homeRoute = useAuthStore((state) => state.homeRoute);

  if (status === 'idle' || status === 'restoring') {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingState label="Loading…" />
      </div>
    );
  }

  if (status === 'authenticated') return <Navigate to={homeRoute()} replace />;

  return <LandingPage />;
}
